// @flow
import React from 'react';
import styled from 'styled-components';

const propTypes = {};
const defaultProps = {};

const StyledGrid = styled.ul`
  background: white;
  display: flex;
  flex-wrap: wrap;
`;

const DayGrid = (props:Object) => {
  return (
    <StyledGrid>
      {props.children}
    </StyledGrid>
  );
};

DayGrid.propTypes = propTypes;
DayGrid.defaultProps = defaultProps;

export default DayGrid;


// WEBPACK FOOTER //
// ./src/modules/common/components/calendar/DayGrid.js